document.addEventListener('DOMContentLoaded', function () {
    if (document.getElementById('download-csv-btn')) {
        const exportBtn = document.getElementById('download-csv-btn')

        exportBtn.addEventListener('click', function () {
            let data = []
            data.push('sep=;')
            // Unconditionally add header row to the data
            const headerRow = document.querySelector('#table-header tr')
            if (headerRow) {
                // Skip the first 'th' element (checkbox column)
                let headerData = Array.from(headerRow.querySelectorAll('th:not(.deploy-cell)'))
                    .slice(1)
                    .map(th => th.innerText)
                    .join(';')
                data.push(headerData)
            }

            // Process the rest of the rows based on checkboxes
            const rows = document.querySelectorAll('#table-body tr')
            let checkboxCount = 0;
            for (let i = 0; i < rows.length; i++) {
                const checkbox = rows[i].querySelector('input[type="checkbox"]')
                if (checkbox && checkbox.checked) {
                    // Skip the first 'td' element (checkbox column)
                    let rowData = Array.from(rows[i].querySelectorAll('td:not(.deploy-cell)'))
                        .slice(1)
                        .map(td => td.innerText.replace(/#/g, ''))
                        .join(';')
                    data.push(rowData)
                    checkboxCount++;
                }
            }

          if(0 == checkboxCount || document.getElementById('select-all').checked) {
            while(2 < data.length) {
              data.pop()
            }
            const report_type = jQuery('.ccare__report-selected').data('value')
            var searchTags = jQuery('.ccare__search-tag')
              .map(function () {
                return jQuery(this).find('.ccare__tag').text().trim();
              })
              .get();

            
            jQuery.post(vars.ajax_url, { action: 'get_work_orders', report_type: report_type, search: searchTags, page: -1 }, function(response) {
              const newWorkOrders = jQuery.parseJSON(response).data
              const headerItems = Array.from(headerRow.querySelectorAll('th'))
                .slice(1)
                .map(th=>th.innerText)
              // get header items 
              for(workOrderKey in newWorkOrders) {
                let itemArray = []
                for(headerKey in headerItems) {
                  for(fieldKey in reportFields) {
                    if(reportFields[fieldKey].toLowerCase().trim() == headerItems[headerKey].toLowerCase().trim()) {
                      itemArray.push(newWorkOrders[workOrderKey][fieldKey].replace(/#/gi, ''))
                      break;
                    }
                  }
                }
                let rowData = itemArray.join(';')
                data.push(rowData)
              }
              buildCSV(data);
            })
          } else {
            buildCSV(data);
          }
        })
    }
})

function buildCSV(data) {
  // Convert data array to CSV string
  const csvContent = 'data:text/csv;charset=utf-8,' + data.join('\n')
  const encodedUri = encodeURI(csvContent)
  const link = document.createElement('a')
  link.setAttribute('href', encodedUri)
  const reportType = jQuery('.ccare__report-selected').data('value')
  // include the date in the export file name
  const date = new Date().toISOString().slice(0, 10)
  link.setAttribute('download', reportType + '-' + date + '.csv')
  document.body.appendChild(link) // Required for Firefox
  link.click()
  document.body.removeChild(link) // Clean up
}
